import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  jsonLd?: object[];
  ogImage?: string;
}

export default function Seo({
  title,
  description,
  keywords,
  canonical = "https://swimchats.github.io/",
  jsonLd = [],
  ogImage = "https://public.readdy.ai/manga/overflow-hero.jpg",
}: SeoProps) {
  useEffect(() => {
    document.title = title;
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", ogImage);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    let canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", canonical);

    const idPrefix = "seo-jsonld-";
    document.querySelectorAll(`script[data-seo="${idPrefix}"]`).forEach((el) => el.remove());
    jsonLd.forEach((obj, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", `${idPrefix}${i}`);
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, keywords, canonical, ogImage, jsonLd]);

  return null;
}